// extracted by mini-css-extract-plugin
export default {"icon":"fouTiMWOzjn","hover":"foug3SnOpwA"};